import type { FunctionComponent, ReactElement } from 'react';
import { useEffect } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { CoreDispatch, useCoreDispatch } from '../../../store/CoreStore';
import { popupActions } from '../../../store/slices/popup/slice';
import { Button, ButtonVariant } from '../../controls/button/Button';
import { Curtain } from '../../curtain/Curtain';
import { PopupType } from '../../popup/types';

import { BlockingModalContent } from './BlockingModalContent';

interface GenericErrorConnectedProps {
  inCurtain?: boolean;
}

export const GenericErrorNoRefreshConnected: FunctionComponent<GenericErrorConnectedProps> = ({
  inCurtain,
}): ReactElement => {
  const dispatch: CoreDispatch = useCoreDispatch();

  const action = [
    <Button
      key="OK"
      tk="OK"
      variant={ButtonVariant.ACCENT}
      onClick={() => {
        dispatch(popupActions.dismissPopup(PopupType.GenericErrorNoRefresh));
      }}
    />,
  ];

  useEffect(() => {
    if (inCurtain) return;
    // Error may occur on initial loading. Remove curtain so that error popup is displayed
    Curtain.remove();
  }, [inCurtain]);

  return (
    <BlockingModalContent actions={action} inCurtain={inCurtain}>
      <L10nText tk="GENERIC_ERROR" placeholder="Please contact Customer Support for assistance" />
    </BlockingModalContent>
  );
};
